// AUPREA carnet rubriques definitions

// Tranches de montants utilisées dans les champs structurés
export const MONTANT_RANGES = [
  "Moins de 1 000 €",
  "1 000 € – 5 000 €",
  "5 000 € – 25 000 €",
  "25 000 € – 100 000 €",
  "100 000 € – 500 000 €",
  "Plus de 500 000 €",
  "Je préfère ne pas préciser",
];

// Type de comptes bancaires
const TYPES_COMPTES = [
  "Compte courant",
  "Compte joint",
  "Compte professionnel",
  "Compte d'épargne",
  "Autre",
];

// Types de livrets / épargne réglementée
const TYPES_LIVRETS = [
  "Livret A",
  "LDDS",
  "LEP",
  "Livret Jeune",
  "PEL / CEL",
  "PEA",
  "Compte titres ordinaire",
  "Assurance-vie",
  "PER",
  "Autre",
];

// Types d'investissements
const TYPES_INVESTISSEMENTS = [
  "SCPI",
  "OPCI",
  "Actions / ETF",
  "Obligations",
  "FCPE / Épargne salariale",
  "Métaux précieux (or, argent…)",
  "Œuvres d'art / objets de collection",
  "Investissement participatif (crowdfunding)",
  "Autre",
];

// Plateformes crypto courantes
const PLATEFORMES_CRYPTO = [
  "Binance",
  "Coinbase",
  "Kraken",
  "Crypto.com",
  "Bitpanda",
  "Ledger (cold wallet)",
  "Trezor (cold wallet)",
  "MetaMask",
  "Autre wallet",
];

// Bénéficiaires de cautionnements
const BENEFICIAIRES_CAUTION = [
  "Banque (prêt immobilier d'un proche)",
  "Banque (prêt professionnel)",
  "Bailleur (location d'un proche)",
  "Société (cautionnement professionnel)",
  "Autre",
];

// Types de crédits en cours
const TYPES_CREDITS = [
  "Crédit immobilier",
  "Crédit auto",
  "Crédit à la consommation",
  "Autre",
];

// Rôles possibles pour une personne de confiance
export const ROLES_PERSONNE_CONFIANCE = [
  "Exécuteur testamentaire",
  "Tuteur des enfants (si mineurs)",
  "Mandataire (mandat de protection future)",
  "Personne à prévenir en cas d'urgence",
  "Détenteur d'une copie des dernières volontés",
  "Autre (préciser)",
];

// Types de lieu d'obsèques
const TYPES_LIEU_OBSEQUES = [
  "Cimetière communal de ma résidence",
  "Cimetière communal de naissance",
  "Caveau familial existant",
  "Crémation – dispersion en mer",
  "Crémation – dispersion en nature",
  "Crémation – urne au columbarium",
  "Crémation – urne conservée par la famille",
  "Aucune préférence",
];

export const RUBRIQUES = [
  {
    id: "identite",
    label: "Identité",
    icon: "User",
    description: "Vos informations personnelles essentielles.",
    fields: [
      { key: "prenom", label: "Prénom", type: "text" },
      { key: "nom", label: "Nom de famille", type: "text" },
      { key: "date_naissance", label: "Date de naissance", type: "date" },
      { key: "lieu_naissance", label: "Lieu de naissance", type: "text" },
      { key: "nationalite", label: "Nationalité", type: "text" },
      { key: "adresse_voie", label: "Adresse postale (n° et voie)", type: "text" },
      { key: "adresse_code_postal", label: "Code postal", type: "text" },
      { key: "adresse_ville", label: "Ville", type: "text" },
      { key: "telephone", label: "Téléphone", type: "text" },
    ],
  },
  {
    id: "famille",
    label: "Famille",
    icon: "Users",
    description: "Vos enfants et, à défaut, vos parents (droit successoral).",
    fields: [
      {
        key: "a_des_enfants",
        label: "Avez-vous des enfants ?",
        type: "select",
        options: ["Oui", "Non"],
        helpText: "Cette information nous permet d'adapter les rubriques suivantes à votre situation successorale.",
      },
      {
        key: "info_enfants_prioritaires",
        type: "info",
        title: "Les enfants sont vos héritiers prioritaires",
        content:
          "En droit français, vos enfants sont <strong>héritiers réservataires prioritaires</strong>. " +
          "Ajoutez-les ci-dessous. Vos parents n'entrant pas dans l'ordre successoral dans ce cas, " +
          "vous pourrez les renseigner dans la rubrique <em>Personnes de confiance</em> si vous le souhaitez.",
        showIf: (vals) => /oui/i.test(vals?.a_des_enfants || ""),
      },
      {
        key: "info_parents_prioritaires",
        type: "info",
        title: "En l'absence d'enfants, vos parents sont vos héritiers prioritaires",
        content:
          "Sans descendance directe, vos parents (et à défaut vos frères et sœurs) " +
          "sont vos héritiers légaux. Merci de renseigner leurs coordonnées ci-dessous.",
        showIf: (vals) => /non/i.test(vals?.a_des_enfants || ""),
      },
      // ===== Parents — visibles seulement en l'absence d'enfants =====
      { key: "prenom_pere", label: "Prénom du père", type: "text",
        showIf: (vals) => /non/i.test(vals?.a_des_enfants || "") },
      { key: "nom_pere", label: "Nom du père", type: "text",
        showIf: (vals) => /non/i.test(vals?.a_des_enfants || "") },
      { key: "adresse_pere", label: "Adresse postale du père", type: "textarea",
        showIf: (vals) => /non/i.test(vals?.a_des_enfants || "") },
      { key: "prenom_mere", label: "Prénom de la mère", type: "text",
        showIf: (vals) => /non/i.test(vals?.a_des_enfants || "") },
      { key: "nom_mere", label: "Nom de la mère (jeune fille)", type: "text",
        showIf: (vals) => /non/i.test(vals?.a_des_enfants || "") },
      { key: "adresse_mere", label: "Adresse postale de la mère", type: "textarea",
        showIf: (vals) => /non/i.test(vals?.a_des_enfants || "") },
      { key: "fratrie", label: "Frères et sœurs", type: "textarea",
        showIf: (vals) => /non/i.test(vals?.a_des_enfants || "") },
    ],
    list: "enfants",
    listShowIf: (profil) => /oui/i.test(profil?.famille?.a_des_enfants || ""),
  },
  {
    id: "couple",
    label: "Situation de couple",
    icon: "Heart",
    description: "Votre statut conjugal et régime matrimonial.",
    fields: [
      {
        key: "statut",
        label: "Statut",
        type: "select",
        options: ["Célibataire", "Marié(e)", "PACS", "Concubinage", "Divorcé(e)", "Veuf/Veuve"],
      },
      {
        key: "regime_matrimonial",
        label: "Régime matrimonial",
        type: "select",
        options: [
          "Communauté réduite aux acquêts (régime légal)",
          "Communauté universelle",
          "Séparation de biens",
          "Participation aux acquêts",
          "Communauté de meubles et acquêts (ancien régime légal avant 1966)",
          "Autre / Régime étranger",
        ],
        helpText: "Cette information nous permet d'évaluer la répartition de votre patrimoine en cas de succession.",
        showIf: (vals) => /marié/i.test(vals?.statut || ""),
      },
      {
        key: "regime_matrimonial_autre",
        label: "Précisez votre régime matrimonial",
        type: "text",
        placeholder: "Ex. régime allemand de Zugewinngemeinschaft…",
        showIf: (vals) => /marié/i.test(vals?.statut || "") && /autre|étranger/i.test(vals?.regime_matrimonial || ""),
      },
      {
        key: "regime_pacs",
        label: "Régime du PACS",
        type: "select",
        options: [
          "Séparation de biens (régime par défaut)",
          "Indivision (régime de la communauté)",
        ],
        helpText: "Le régime de séparation de biens s'applique automatiquement si aucune convention spécifique n'a été signée.",
        showIf: (vals) => /pacs/i.test(vals?.statut || ""),
      },
      {
        key: "souhait_accompagnement_testament_pacs",
        label: "Souhaitez-vous être accompagné(e) par l'un de nos partenaires pour la rédaction de votre testament ?",
        type: "select",
        options: ["Oui, contactez-moi", "Non merci", "Plus tard"],
        showIf: (vals) => /pacs/i.test(vals?.statut || ""),
      },
      { key: "prenom_conjoint", label: "Prénom du conjoint / partenaire", type: "text" },
      { key: "nom_conjoint", label: "Nom du conjoint / partenaire", type: "text" },
      { key: "date_naissance_conjoint", label: "Date de naissance du conjoint / partenaire", type: "date" },
    ],
  },
  {
    id: "documents_juridiques",
    label: "Documents juridiques",
    icon: "FileText",
    description: "Testament, mandats, donations en place.",
    fields: [
      { key: "testament", label: "Testament rédigé ?", type: "select", options: ["Oui", "Non"] },
      { key: "lieu_testament", label: "Lieu de conservation", type: "text" },
      {
        key: "info_mandat_protection",
        type: "info",
        title: "Mandat de protection future",
        content:
          "Le <strong>mandat de protection future</strong> vous permet de désigner à l'avance la ou les personnes de confiance qui géreront vos affaires personnelles et patrimoniales " +
          "si vous n'étiez plus en capacité de le faire vous-même (maladie, accident, perte d'autonomie). " +
          "<br/><br/>" +
          "Sans ce document, c'est un <em>juge des tutelles</em> qui désignera un tuteur ou curateur, sans tenir compte de vos préférences. " +
          "Anticiper ce choix vous permet de garder la main sur qui s'occupera de vous et de vos biens le moment venu.",
      },
      { key: "mandat_protection", label: "Avez-vous mis en place un mandat de protection future ?", type: "select", options: ["Oui", "Non"] },
      {
        key: "souhait_accompagnement_mandat",
        label: "Souhaitez-vous être accompagné(e) par l'un de nos partenaires pour la mise en place de votre mandat de protection future ?",
        type: "select",
        options: ["Oui, contactez-moi", "Non merci", "Plus tard"],
        showIf: (vals) => {
          const a = (vals?.mandat_protection || "").toLowerCase();
          return a === "non" || a === "";
        },
      },
      { key: "donations", label: "Donations effectuées", type: "textarea" },
    ],
  },
  {
    id: "patrimoine_immobilier",
    label: "Patrimoine immobilier",
    icon: "Home",
    description: "Ajoutez chacun de vos biens (résidence principale, secondaire, locatif, foncier).",
    fields: [
      {
        key: "info_intro_immo",
        type: "info",
        title: "Vos biens immobiliers",
        content:
          "Ajoutez chaque bien un par un via le bouton <strong>« Ajouter un bien immobilier »</strong> ci-dessous. " +
          "Vous pourrez préciser pour chaque bien son type (résidence principale, secondaire, investissement locatif, foncier), " +
          "sa valeur, son mode de détention et l'éventuel crédit en cours.",
      },
    ],
    list: "biens",
  },
  {
    id: "patrimoine_financier",
    label: "Patrimoine financier",
    icon: "TrendingUp",
    description: "Comptes, épargne, assurance-vie.",
    fields: [
      {
        key: "banques",
        label: "Banques (liste de vos comptes)",
        type: "repeater",
        itemLabel: "compte",
        itemFields: [
          { key: "banque", label: "Banque", type: "text", placeholder: "Ex. BNP Paribas, Crédit Agricole…" },
          { key: "type_compte", label: "Type de compte", type: "select", options: TYPES_COMPTES },
          { key: "montant_range", label: "Solde estimé", type: "select", options: MONTANT_RANGES },
        ],
      },
      {
        key: "livrets",
        label: "Livrets / épargne réglementée",
        type: "repeater",
        itemLabel: "livret",
        itemFields: [
          { key: "type", label: "Type de livret", type: "select", options: TYPES_LIVRETS },
          { key: "banque", label: "Banque / établissement", type: "text", placeholder: "Ex. La Banque Postale" },
          { key: "montant_range", label: "Montant détenu", type: "select", options: MONTANT_RANGES },
        ],
      },
      {
        key: "assurance_vie",
        label: "Assurance-vie souscrite ?",
        type: "select",
        options: ["Oui", "Non"],
      },
      { key: "clause_beneficiaire", label: "Clause bénéficiaire (à jour ?)", type: "textarea" },
      {
        key: "investissements",
        label: "Autres investissements",
        type: "repeater",
        itemLabel: "investissement",
        itemFields: [
          { key: "type", label: "Type d'investissement", type: "select", options: TYPES_INVESTISSEMENTS },
          { key: "detail", label: "Précision (nom du produit, gestionnaire…)", type: "text" },
          { key: "montant_range", label: "Valeur estimée", type: "select", options: MONTANT_RANGES },
        ],
      },
    ],
  },
  {
    id: "dettes",
    label: "Dettes & engagements",
    icon: "AlertCircle",
    description: "Crédits, cautions et engagements financiers.",
    fields: [
      {
        key: "credits",
        label: "Crédits en cours",
        type: "repeater",
        itemLabel: "crédit",
        itemFields: [
          { key: "type_credit", label: "Type de crédit", type: "select", options: TYPES_CREDITS },
          { key: "montant_initial", label: "Montant initial emprunté (€)", type: "number", placeholder: "Ex. 180000" },
          { key: "solde_restant", label: "Solde restant dû (€)", type: "number", placeholder: "Ex. 95000" },
          { key: "duree_valeur", label: "Durée du crédit", type: "number", placeholder: "Ex. 20" },
          { key: "duree_unite", label: "Unité de durée", type: "select", options: ["mois", "années"] },
          { key: "date_fin", label: "Date de fin de crédit", type: "date" },
        ],
      },
      {
        key: "souhait_rachat_credits",
        label: "Souhaitez-vous être accompagné(e) pour racheter vos crédits ? Cela peut vous permettre de réduire vos mensualités.",
        type: "select",
        options: ["Oui", "Non"],
        showIf: (vals) => {
          const v = vals?.credits || "";
          if (!v || typeof v !== "string") return false;
          const t = v.trim();
          if (!t.startsWith("[")) return false;
          try {
            const arr = JSON.parse(t);
            return Array.isArray(arr) && arr.length > 0;
          } catch (_e) { return false; }
        },
      },
      {
        key: "cautions",
        label: "Cautionnements donnés",
        type: "repeater",
        itemLabel: "cautionnement",
        itemFields: [
          { key: "beneficiaire", label: "Bénéficiaire du cautionnement", type: "select", options: BENEFICIAIRES_CAUTION },
          { key: "personne", label: "Pour qui (nom / société)", type: "text", placeholder: "Ex. mon fils Paul" },
          { key: "montant_range", label: "Montant garanti", type: "select", options: MONTANT_RANGES },
        ],
      },
      { key: "autres_engagements", label: "Autres engagements", type: "textarea" },
    ],
  },
  {
    id: "dernieres_volontes",
    label: "Dernières volontés",
    icon: "Feather",
    description: "Funérailles, dons d'organes, messages aux proches.",
    fields: [
      {
        key: "type_obseques",
        label: "Type d'obsèques",
        type: "select",
        options: ["Inhumation", "Crémation", "Indifférent"],
      },
      {
        key: "lieu_obseques",
        label: "Lieu / cimetière souhaité",
        type: "structured",
        subFields: [
          { key: "type_lieu", label: "Type de lieu", type: "select", options: TYPES_LIEU_OBSEQUES },
          { key: "commune", label: "Commune souhaitée", type: "text", placeholder: "Ex. Pointe-à-Pitre" },
          { key: "code_postal", label: "Code postal", type: "text", placeholder: "Ex. 97110" },
          { key: "precision", label: "Précision (facultatif)", type: "text", placeholder: "Nom du caveau, parcelle…" },
        ],
      },

      // --- Bloc Assurance obsèques ---
      {
        key: "assurance_obseques",
        label: "Avez-vous une assurance obsèques ?",
        type: "select",
        options: ["Oui", "Non"],
      },
      {
        key: "assurance_obseques_nom",
        label: "Nom de l'assurance (obsèques)",
        type: "text",
        placeholder: "Ex. Prévoyance Obsèques CNP",
        showIf: (vals) => /oui/i.test(vals?.assurance_obseques || ""),
      },
      {
        key: "assurance_obseques_contrat",
        label: "Numéro de contrat (obsèques)",
        type: "text",
        placeholder: "Ex. 12345678",
        showIf: (vals) => /oui/i.test(vals?.assurance_obseques || ""),
      },
      {
        key: "souhait_accompagnement_obseques",
        label: "Souhaitez-vous être accompagné(e) par l'un de nos partenaires pour souscrire une assurance obsèques ?",
        type: "select",
        options: ["Oui", "Non"],
        showIf: (vals) => /non/i.test(vals?.assurance_obseques || ""),
      },

      // --- Bloc Assurance rapatriement ---
      {
        key: "assurance_rapatriement",
        label: "Avez-vous une assurance rapatriement ?",
        type: "select",
        options: ["Oui", "Non"],
      },
      {
        key: "assurance_rapatriement_nom",
        label: "Nom de l'assurance (rapatriement)",
        type: "text",
        placeholder: "Ex. Mondial Assistance",
        showIf: (vals) => /oui/i.test(vals?.assurance_rapatriement || ""),
      },
      {
        key: "assurance_rapatriement_contrat",
        label: "Numéro de contrat (rapatriement)",
        type: "text",
        placeholder: "Ex. 12345678",
        showIf: (vals) => /oui/i.test(vals?.assurance_rapatriement || ""),
      },
      {
        key: "souhait_accompagnement_rapatriement",
        label: "Souhaitez-vous être accompagné(e) par l'un de nos partenaires pour souscrire une assurance rapatriement ?",
        type: "select",
        options: ["Oui", "Non"],
        showIf: (vals) => /non/i.test(vals?.assurance_rapatriement || ""),
      },

      { key: "don_organes", label: "Don d'organes", type: "select", options: ["Oui", "Non", "Sans préférence"] },
      { key: "message_proches", label: "Message à vos proches", type: "textarea" },
    ],
  },
  {
    id: "patrimoine_numerique",
    label: "Patrimoine numérique",
    icon: "Cloud",
    description: "Vos comptes en ligne, cryptomonnaies et données numériques.",
    fields: [
      {
        key: "info_intro_numerique",
        type: "info",
        title: "Patrimoine numérique",
        content:
          "Vos comptes en ligne (réseaux sociaux, messageries, plateformes financières, abonnements, etc.) " +
          "font partie de votre patrimoine numérique. Pour permettre à vos proches de les identifier, " +
          "indiquez pour chaque compte le type de plateforme, l'adresse email associée et votre pseudo/identifiant.",
      },
      {
        key: "info_alerte_securite_numerique",
        type: "info",
        variant: "warning",
        title: "⚠️ Ne renseignez jamais de mot de passe sur cette plateforme",
        content:
          "Pour votre sécurité, ne saisissez aucun mot de passe, code PIN ou identifiant de connexion sensible dans AUPRÉA. " +
          "Indiquez uniquement les informations permettant d'<strong>identifier</strong> vos comptes " +
          "(plateforme, email associé, pseudo). La gestion de vos mots de passe doit se faire via un " +
          "<strong>gestionnaire de mots de passe dédié</strong>.",
      },
      { key: "gestionnaire_mdp", label: "Gestionnaire de mots de passe utilisé", type: "text",
        placeholder: "Ex. 1Password, Bitwarden, Dashlane…" },
      {
        key: "comptes_numeriques",
        label: "Mes comptes numériques",
        type: "repeater",
        itemLabel: "compte",
        itemFields: [
          { key: "type_plateforme", label: "Type de plateforme", type: "select", options: [
            "Réseau social", "Messagerie email", "Compte bancaire / financier en ligne",
            "Plateforme de stockage cloud", "Abonnement / service en ligne", "Autre",
          ]},
          { key: "nom_precis", label: "Nom exact", type: "text", placeholder: "Ex. Instagram, Gmail, Dropbox…" },
          { key: "email_rattache", label: "Email rattaché", type: "text", placeholder: "prenom@email.fr" },
          { key: "pseudo", label: "Pseudo / identifiant", type: "text", placeholder: "@monpseudo ou identifiant" },
        ],
      },
      { key: "comptes_importants", label: "Note libre complémentaire (facultatif)", type: "textarea",
        helpText: "Ancien champ conservé pour la rétrocompatibilité — vous pouvez recopier son contenu dans la liste ci-dessus." },
      {
        key: "cryptos",
        label: "Cryptomonnaies / wallets",
        type: "repeater",
        itemLabel: "wallet",
        itemFields: [
          { key: "plateforme", label: "Plateforme / wallet", type: "select", options: PLATEFORMES_CRYPTO },
          { key: "detail", label: "Précision (compte, alias…)", type: "text", placeholder: "Ex. compte principal" },
          { key: "montant_range", label: "Valeur estimée", type: "select", options: MONTANT_RANGES },
        ],
      },
      { key: "souhait_numerique", label: "Souhait sur ces données", type: "textarea" },
    ],
  },
  {
    id: "sante",
    label: "Don d'organes",
    icon: "Shield",
    description: "Faites connaître votre position auprès de vos proches.",
    fields: [
      {
        key: "info_don_organes",
        type: "info",
        title: "Le saviez-vous ?",
        content:
          "En France, depuis 2017, <strong>toute personne majeure est présumée donneuse d'organes et de tissus</strong> après son décès, sauf si elle s'est inscrite de son vivant au <em>Registre National des Refus</em>. " +
          "Vos proches seront consultés, mais la décision repose d'abord sur votre volonté exprimée. " +
          "<br/><br/>" +
          "👉 <strong>L'important : faites connaître votre position à vos proches</strong>, qu'elle soit favorable ou défavorable. " +
          "C'est le meilleur moyen d'éviter qu'ils aient à décider à votre place dans un moment difficile." +
          "<br/><br/>" +
          "<a href='https://www.registrenationaldesrefus.fr' target='_blank' rel='noreferrer' style='color:var(--auprea-blue);text-decoration:underline;'>S'inscrire au Registre National des Refus (en 2 min)</a> · " +
          "<a href='https://www.dondorganes.fr' target='_blank' rel='noreferrer' style='color:var(--auprea-blue);text-decoration:underline;'>En savoir plus sur dondorganes.fr</a>",
      },
      {
        key: "position_don_organes",
        label: "Ma position personnelle",
        type: "select",
        options: [
          "Je suis favorable au don de mes organes",
          "Je ne souhaite pas donner mes organes",
          "Je préfère en parler avec mes proches",
        ],
      },
      {
        key: "proches_informes",
        label: "Mes proches sont-ils informés de ma position ?",
        type: "select",
        options: ["Oui, je leur en ai parlé", "Pas encore, je vais le faire", "Je préfère en parler bientôt"],
      },
      {
        key: "note_personnelle",
        label: "Notes personnelles (facultatif)",
        type: "textarea",
      },
    ],
  },
  {
    id: "personnes_confiance",
    label: "Personnes de confiance",
    icon: "UserCheck",
    description: "Les personnes à prévenir, leur rôle, et vos coordonnées notariales.",
    fields: [
      {
        key: "info_notaire_intro",
        type: "info",
        title: "Votre notaire",
        content:
          "Renseignez ci-dessous les coordonnées de votre notaire, ou indiquez si vous n'en avez pas encore. " +
          "En l'absence de notaire, vous pourrez en contacter un directement depuis notre <em>Annuaire pro</em>.",
      },
      {
        key: "has_notaire",
        label: "Avez-vous déjà un notaire ?",
        type: "select",
        options: ["Oui", "Non"],
      },
      {
        key: "notaire_details",
        label: "Coordonnées de votre notaire",
        type: "structured",
        showIf: (vals) => /oui/i.test(vals?.has_notaire || ""),
        subFields: [
          { key: "nom", label: "Nom du notaire / de l'étude", type: "text", placeholder: "Ex. Étude Maître Dupont" },
          { key: "adresse", label: "Adresse de l'étude", type: "text", placeholder: "N°, rue, code postal, ville" },
          { key: "telephone", label: "Téléphone", type: "text", placeholder: "01 23 45 67 89" },
          { key: "email", label: "Email", type: "email", placeholder: "etude@notaire.fr" },
        ],
      },
      {
        key: "info_annuaire_notaire",
        type: "info",
        title: "Vous n'avez pas encore de notaire ?",
        content:
          "Vous pouvez prendre contact avec l'un de nos notaires partenaires directement depuis l'Annuaire pro : " +
          "<a href='/annuaire' style='color:var(--auprea-blue);text-decoration:underline;font-weight:600;'>Ouvrir l'Annuaire pro →</a>",
        showIf: (vals) => /non/i.test(vals?.has_notaire || ""),
      },
      {
        // Ancien champ conservé pour migration douce : visible uniquement si l'utilisateur avait déjà saisi
        // du texte libre et n'a pas encore choisi Oui/Non dans la nouvelle question.
        key: "notaire",
        label: "Ancienne saisie « Coordonnées de votre notaire »",
        type: "textarea",
        helpText: "Ancien format conservé pour éviter toute perte de données. Recopiez ces informations dans le formulaire ci-dessus, puis effacez cette zone.",
        showIf: (vals) => Boolean((vals?.notaire || "").trim()) && !((vals?.has_notaire || "").trim()),
      },
    ],
    list: "personnes_confiance",
  },
];

export const RUBRIQUE_BY_ID = Object.fromEntries(RUBRIQUES.map((r) => [r.id, r]));
